import { render, staticRenderFns } from "./proforma_client.vue?vue&type=template&id=536aa756&"
import script from "./proforma_client.vue?vue&type=script&lang=js&"
export * from "./proforma_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports